module.exports = {
      id: "author-avator-usage",
      viewBox: "0 0 102 102",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#author-avator",
      toString: function () {
        return this.url;
      }
    }